import React, { useMemo } from 'react';
import TickIcon from '@mui/icons-material/Done';
import { TemplateType } from '@server/trading-templates/schemas/input.schema';
import { ManageGridColumn } from '@client/foundation/shared/components/manage-grid';
import { TemplateRow } from './template-grid.types';
import { canUseDefaultTemplate } from './template-grid.utils';

type TemplateGridColumnDefinition = {
  column: ManageGridColumn<TemplateRow>;
  isVisible?: (templateType: TemplateType) => boolean;
};

type UseTemplateGridColumnsProps = {
  templateType: TemplateType;
};

// Produces dynamic columns with visibility rules based on template type.
// This keeps conditional rendering out of TemplateGrid and makes future
// optional columns easier to plug in.
export const useTemplateGridColumns = ({
  templateType
}: UseTemplateGridColumnsProps) => {
  return useMemo(() => {
    const definitions: TemplateGridColumnDefinition[] = [
      {
        column: {
          key: 'name',
          header: 'Name',
          renderCell: (row) => row.name
        }
      },
      {
        column: {
          key: 'default',
          header: 'Default',
          renderCell: (row) =>
            row.isDefault ? <TickIcon color="success" fontSize="small" /> : null
        },
        isVisible: canUseDefaultTemplate
      }
    ];

    return definitions
      .filter((definition) =>
        definition.isVisible ? definition.isVisible(templateType) : true
      )
      .map((definition) => definition.column);
  }, [templateType]);
};
